import { Error as ApiError } from "~/api/Api";

export interface MappedValidationError {
  code: number;
  message: string;
}

export const VALIDATION_ERRORS = {
  SITE_QUOTA_EXCEEDED: 10000,
  USER_EMAIL_TAKEN: 10001,
} as const;

export function mapValidationErrors(error: ApiError): MappedValidationError[] {
  const codes = error.validation_codes;
  if (!codes) return [];

  const messages = error.validation_messages ?? [];

  return codes.map((code, index) => ({
    code,
    message: messages[index] ?? "",
  }));
}
